import React from "react";

const SearchBox = ({ onSearch }) => {
    return (
        <div className="relative w-full">
            <input
                type="text"
                placeholder="Search by subject, course number, title, or CRN"
                onChange={(e) => onSearch(e.target.value)}
                className={`
                    form-input w-full pl-10 pr-4 py-2
                    bg-white
                    border border-gray-300
                    rounded-md
                    h-10
                    text-sm
                    placeholder-gray-400
                    focus:outline-none
                    focus:ring-2 focus:ring-indigo-500
                    focus:border-indigo-500
                `}
            />
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                {/* Magnifying Glass Icon */}
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-5 h-5 text-gray-500"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                    />
                </svg>
            </div>
        </div>
    );
};

export default SearchBox;